<template>
  <Prompt :show-prompt="isShow">
    <div class="confirm-wrap">
      <p class="confirm-text">
        使用蜂助手钱包支付需要绑定银行卡
      </p>
      <div class="confirm-btns">
        <button @click="toBindCard">
          去绑卡
        </button>
        <button @click="cancle">
          取消
        </button>
      </div>
    </div>
  </Prompt>
</template>

<script>
  import Prompt from './Prompt'
  export default {
    components: {Prompt},
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      callBack: {
        type: Function,
        default: () => {}
      }
    },
    // watch: {
    //   isShow: {
    //     immediate: true,
    //     handler(newValue) {

    //     }
    //   }
    // },
    methods: {
      toBindCard() {
        this.$emit('onClose')
        this.callBack()
      },
      cancle () {
        this.$emit('onClose')
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "../assets/common.scss";
.confirm-wrap {
  @extend %dialog-content;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 100px;
  .confirm-text {
    font-size: 40px;
  }
  .confirm-btns {
    display: flex;
    justify-content: space-around;
    margin-top: 120px;
    button {
      @extend %btns;
      width: 367px;
      height: 108px;
      @extend %btnsColor;
      border-radius: 54px;
      border: none;
      font-size: 45px;
      color: #000000;
    }
  }
}
</style>